import React,{Component} from "react"
//import ButtonGroup from './ButtonGroup'
import 'antd/dist/antd.css'
import { Layout, Menu, Icon } from 'antd';
import { Link }from 'react-router-dom'

//const {Title} = Typography
const {  Sider } = Layout;
const { SubMenu } = Menu;


class NavigationPane extends Component{

    constructor(){
        super()
        this.state = {
          brand : <span><h3 style={{color:"red"}}>Resource Management</h3></span>//<img src="rm_logo.png" width={196}></img>
        }
    }

    onCollapse = collapsed => {
        console.log(collapsed);
        collapsed ? 
        this.setState({ collapsed , brand:<img src="rm_logo.png" width={96}></img>}):this.setState({ collapsed , brand:<img src="rm_logo.png" width={196}></img>})
         
     
    };


    render(){

        const styles = {

            navPaneStyles:{
                padding: "10px 5px",
                backgroundColor : "LightGray",
              // borderRight : "1px solid black",
                height : "500px"
                
            },
            brand:{
             // color:"white", 
              textAlign:"center" , 
              fontSize:"24px",
             marginBottom: "20px",
            marginTop:"10px"}
    
         }
        // console.log(this.props.buttonEvent)

       return(
        
       
        <Sider theme="light" collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
          <div className="logo" style={styles.brand}>{this.state.brand}</div>
          <Menu  defaultSelectedKeys={['1']} mode="inline">
          
              <Menu.Item key="dashboard" >
                <Link to='/dashboard'> 
                  <Icon type="desktop" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>
            
            <SubMenu
              key="Empoyees"
              title={
                <span>
                  <Icon type="user" />
                  <span>Employees</span>
                </span>
              }
            >
           <Menu.Item key="addEmployee"> <Link to='/addemployee'>Add Empoyee </Link></Menu.Item>
           <Menu.Item key="viewEmployees"><Link to='/viewemployees'>View Empoyees</Link></Menu.Item>
           </SubMenu>
            
            <SubMenu
                key="Assets"
                title={
                  <span>
                    <Icon type="shop" />
                    <span>Assets</span>
                  </span>
                }
            >
                <Menu.Item key="warehouses"> <Link to='/warehouses'> Warehouses </Link></Menu.Item>
                <Menu.Item key="vehicles"><Link to='/vehicles'>Vehicles</Link></Menu.Item>
             </SubMenu>

            {/* <Menu.Item key="payroll" >
                <Link to='/payroll'> 
                  <Icon type="desktop" />
                  <span>Payroll</span>
                </Link>
              </Menu.Item> */}
              <Menu.Item key="attendance" >
                <Link to='/attendance'> 
                  <Icon type="user" />
                  <span>Attendance</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="settings" >
                <Link to='/settings'> 
                  <Icon type="setting" />
                  <span>Settings</span>
                </Link>
              </Menu.Item>
        
            </Menu>

        </Sider>
        
        
       )
    }


}

export default NavigationPane

